<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>保险到期提醒</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->

          <el-form
              label-width="80px"
              size="small"
            :inline="false"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            autocomplete="on">
            <el-row :gutter="18">
              <el-col :span="6">
                <shopCompanyTemp ref="shopCompanyTemp" @changeData="setshopId" ></shopCompanyTemp>
              </el-col>
              <el-col :span="6">
                <el-form-item label="车牌号" size="small" >
                  <el-input size="small" clearable placeholder="请输入车牌号" v-model="searchForm.plate_number" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-button size="small" type="primary" @click="searchSubmit('','')">搜索</el-button>
              </el-col>
              <el-col :span="1">
                <el-form-item>
                    <span>
                          <el-button @click="toExcel()">导出Excel</el-button>
                    </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item >

              <el-button
                  v-for="(item, index) in prodcutList"
                  :key="index"
                  :class="{ 'active-button': selectedProductIndex === index }"
                  style="height: 100%;float: left;width: 13%; font-weight: bold;line-height: 20px; font-size: 16px;"
                  @click="searchSubmit(item.id,index)">
                {{item.name}}
              </el-button>

            </el-form-item>
            <el-form-item label-width="0px">
              <div
                  v-for="(item, index) in sumData"
                  :key="index"
              >
                <el-button
                    :type="item.type"
                    @click="searchSubmit2(item.id,index)"
                    style="height: 100%;float: left;width: 20%; font-weight: bold;line-height: 20px; font-size: 16px;"
                >
                  <div>{{item.name}}</div>
                  <div>台次：{{item.total}}</div>

                </el-button>
              </div>

            </el-form-item>


          </el-form>



      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
        stripe
        border
        size="mini">
        <el-table-column
          label="车牌号"
          width="105"
           align="center"
          prop="plate_number">
        </el-table-column>
        <el-table-column
          label="保险到期"
          align="center">
          <template slot-scope="scope">
            <el-table
              :data="scope.row.data"
              stripe border
              size="mini"
              :header-cell-style="{background:'#e5e5e5',color:'#333333'}">

              <el-table-column
                  label="险种"
                  prop="product_name"
                  :show-overflow-tooltip="true">

              </el-table-column>
              <el-table-column
                  label="保司"
                  prop="corp_name">

              </el-table-column>
              <el-table-column
                  label="保司电话"
                  prop="corp_tel">

              </el-table-column>
              <el-table-column
                  label="保险止期"
                  prop="end_time">
                  <template slot-scope="scope">
                    {{scope.row.end_time |dateFormat}}
                  </template>
              </el-table-column>
              <el-table-column
                  label="剩余天数"
                  prop="end_day">

              </el-table-column>
              <el-table-column
                  label="保单"
                  width="105"
                  align="center"
                  prop="plate_number">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.policy_no_pdf_url" type="primary" size="mini"  @click="goDoc(scope.row)">查看</el-button>
                  <el-button v-if="!scope.row.policy_no_pdf_url" size="mini">暂无</el-button>
                </template>
              </el-table-column>

              <el-table-column label="续保" >
                <template slot-scope="scope2" v-if="[17,18].indexOf(scope2.row.product_id) === -1">
                  <router-link :to="{path:  '/insuranceSysProduct', query:{reneInfo:scope2.row}}" exact  title="去续保">
                    去续保
                  </router-link>
                </template>
              </el-table-column>

              <el-table-column label="不续保" >
                <template slot-scope="scope" v-if="[17,18].indexOf(scope.row.product_id) === -1">
                  <el-button @click="noRenewal(scope.row.order_id,scope.row.plate_number)" size="mini">不续保</el-button>
                </template>
              </el-table-column>

            </el-table>
          </template>
        </el-table-column>

        <el-table-column
            label="所有人"
            prop="allPerson"
            width="180px"
            align="center"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
          label="车主"
          prop="username"
          width="60px"
           align="center"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="电话"
          prop="mobile"
           align="center"
          width="95px"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 不续保 -->
    <el-dialog :title="dilogName" :visible.sync="isnoRenewal" width="500px" :before-close="handleBeforeClose">
      <el-form
          :inline="false"
          :model="noRenewalform"
          label-width="90px"
          autocomplete="on">

        <el-form-item label="不续保类型" size="small">
          <el-select  v-model="noRenewalform.type" placeholder="请选择类型" @change="noReneType">
            <el-option label="此单不续保" :value="1"></el-option>
            <el-option label="车辆过户" :value="2"></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleBeforeClose()">取 消</el-button>
        <el-button type="primary" @click="noRenewalSubmitForm('policyNQform')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';    //日期时间转换
  import shopCompanyTemp from "../common/shopCompanyTemp.vue";
  import table2excel from 'js-table2excel'
  export default {
    name: "shipCompany",
    components: {
      shopCompanyTemp,
    },
    props: {},
    data() {
      return {
        selectedProductIndex : 0,
        selectedDayIndex : 0,
        sumData:[],
        prodcutList:[
          {id:0,name:'全部'},
          // {id:1,name:'车牌'},
          {id:2,name:'交强商业'},
          {id:3,name:'超赔'},
          {id:4,name:'雇主'},
          {id:5,name:'驾乘'},
          {id:6,name:'货物'}
        ],
        // 搜索
        searchForm: {
          name: '',
          credit_code:'',
          day:0,
          product_id:1,
          shop_id:'',
        },
        searchRules: {
          name: [
            { required: true, message: "请输入公司名称", trigger: "blur" },
          ],
        },
        // 数据
        tableLoadData: [],
        tableLoadData2: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        title: '',
        isnoRenewal: false,
        dilogName:'',
        noRenewalform: {
          type: 1,
          order_id: '',
          plate_number:""
        },
      };
    },
    created() {
      this.DataList();
      this.DataSumList()
    },
    filters: {
      /**
       * @param {
       *
       * }
       */
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },

       dateTime(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },


    },
    methods: {
      DataSumList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        if(this.searchForm.day){
          param.day=this.searchForm.day;
        }
        if(this.searchForm.product_id){
          param.type=this.searchForm.product_id;
        }
        if(this.searchForm.shop_id){
          param.shop_id=this.searchForm.shop_id;
        }
        if(this.searchForm.member_id){
          param.member_id=this.searchForm.member_id;
        }
        if(this.searchForm.plate_number){
          param.plate_number=this.searchForm.plate_number;
        }
        this.$axios.getCarRemindBtn(param).then(res=>{
          if(res.code == 200){
            this.sumData = res.data
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize: this.limit,
        }
        if(this.searchForm.day){
          param.day=this.searchForm.day;
        }
        if(this.searchForm.product_id){
          param.type=this.searchForm.product_id;
        }
        if(this.searchForm.shop_id){
          param.shop_id=this.searchForm.shop_id;
        }
        if(this.searchForm.member_id){
          param.member_id=this.searchForm.member_id;
        }
        if(this.searchForm.plate_number){
          param.plate_number=this.searchForm.plate_number;
        }
        this.$axios.remindInsuranceList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      noReneType(value){
        this.noRenewalform.type = value;
      },
      setshopId(value){
        //this.form.plate_number = value
        this.searchForm.shop_id = value;
        this.tableLoadData=[];
        this.page=1;
        this.DataList();
        this.sumData=[];
        this.DataSumList();
      },
      searchSubmit(product_id,index) {
        if (product_id){
          this.selectedProductIndex = index;
        }
        if (index){
          this.searchForm.product_id=product_id;
        }
        this.tableLoadData=[];
        this.page=1;
       this.DataList();
       this.sumData=[];
       this.DataSumList();
      },
      searchSubmit2(day,index) {
         this.selectedDayIndex = index;
        this.searchForm.day = day;
        this.tableLoadData=[];
        this.page=1;
       this.DataList();
       this.sumData=[];
       this.DataSumList();
      },
      goDoc(row){
        ////console.log(row)
        if(row.policy_no_pdf_url.length>0){
          return new Promise((resolve, reject) => {
            let blob = null;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", row.policy_no_pdf_url);
            xhr.responseType = "blob";
            xhr.onload = () => {
              blob = xhr.response;
              const blobob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
              const href = window.URL.createObjectURL(blobob);
              window.open(href, 'newWindow');
              resolve(row.policy_no_pdf_url);
            };
            xhr.onerror = (e) => {
              reject(e)
            };
            xhr.send();
          });
        }else{
          alert("暂无文件")
        }
      },
      //不去续保
      noRenewal(order_id,plate_number){
        this.isnoRenewal = true;
        this.dilogName = "不续保选项"
        this.noRenewalform.order_id = order_id
        this.noRenewalform.plate_number = plate_number

      },
      handleBeforeClose(){
        this.isnoRenewal = false;
        this.noRenewalform = [];
      },
      noRenewalSubmitForm(){
        this.$confirm('确定不续保, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log('测试：',this.noRenewalform)
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            order_id: this.noRenewalform.order_id,
            plate_number: this.noRenewalform.plate_number,
            type:this.noRenewalform.type
          }

          this.$axios.goNoRenewalDeal(param).then(res=>{
            if(res.code == 200){
              //修改订单状态 或者 车辆是否过户
              this.tableLoadData=[];
              this.page=1;
              this.DataList();
              this.sumData=[];
              this.DataSumList();
              this.handleBeforeClose()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            //console.log(error);
          })

        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消不续保'
          });
          this.handleBeforeClose()
        });

      },
      getTime (time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
        return y + '-' + m + '-' + d
      },
      //支持导出图片和类型转换
      toExcel() {
        const column = [
          {
            title: '车牌号',
            key: 'plate_number',
            type: 'text'
          },
          {
            title: '险种',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '保司',
            key: 'corp_name',
            type: 'text'
          },
          {
            title: '保司电话',
            key: 'corp_tel',
            type: 'text'
          },
          {
            title: '保险止期',
            key: 'end_time',
            type: 'text'
          },
          {
            title: '剩余天数',
            key: 'end_day',
            type: 'text'
          },
          {
            title: '车主',
            key: 'username',
            type: 'text'
          },
          {
            title: '电话',
            key: 'mobile',
            type: 'text'
          }
        ]
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
          pageSize: this.limit,
        }
        if(this.searchForm.day){
          param.day=this.searchForm.day;
        }
        if(this.searchForm.product_id){
          param.type=this.searchForm.product_id;
        }
        if(this.searchForm.shop_id){
          param.shop_id=this.searchForm.shop_id;
        }

        this.$axios.getCarRemindToExcel(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData2 = res.data;
            this.tableLoadData2.forEach(item => {
              item.end_time = item.end_time?this.getTime(item.end_time*1000):'';
            })

            if(this.tableLoadData2.length>0){
              table2excel(column, this.tableLoadData2, '保险到期报表')
            }else{
              this.$message.error('暂无数据导出');
            }
          }else {
            this.$message.error(res.msg);
          }

        }).catch(error=>{
          //console.log(error);
        })
      },
    },
  };
</script>
<style scoped>
  .el-descriptions-row th:nth-child(1){color: #ff0000;}
  .el-descriptions-row th:nth-child(2){color: #e6a23c;}
  .el-descriptions-row th:nth-child(3){color: #a71d5d;}
  .el-descriptions-row th:nth-child(4){color: #B500FE;}
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
  .active-button {
  color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}

</style>



// WEBPACK FOOTER //
// src/view/remind/insuranceList.vue